<!--
 * @Author: kangkang 1278279046@qq.com
 * @Date: 2022-05-24 15:21:51
 * @LastEditors: kangkang 1278279046@qq.com
 * @LastEditTime: 2023-01-06 14:59:25
 * @FilePath: \experience-pc\src\components\LoginAlert.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="modal-mask">
    <div class="modal-confirm">
      <div class="close-btn" @click="closeAction">
        <img src="@/assets/img/close.png" alt="" />
      </div>
      <span class="text-center text-bold f20" style="">经验派</span>
      <span v-if="isBindPhone">绑定手机号</span>
      <span class="text-center f14" v-else>{{
        isWxLogin ? "微信扫码登录" : "短信快捷登录"
      }}</span>
      <div v-if="!isWxLogin || hasBindPhone">
        <div class="margin-top-20">
          <el-input v-model="userName" placeholder="请输入手机号" />
        </div>
        <div class="margin-top-20 flex-row">
          <div class="code-box">
            <el-input v-model="verificationCode" placeholder="请输入验证码">
            </el-input>
          </div>
          <div class="code-btn" @click="getCode" v-if="timeNum == 60">
            获取验证码
          </div>
          <div class="time-btn" v-else>{{ timeNum }}s</div>
        </div>
      </div>
      <div class="wx-code-box" v-else>
        <!-- @click="isBindPhone = !isBindPhone" -->
        <div id="wxCode" class="wx-code">
          <!-- <img :src="qrCode" alt="" /> -->
          <wxlogin
            :appid="wechat_app_id"
            :scope="'snsapi_login'"
            :theme="'black'"
            :redirect_uri="
              encodeURIComponent(
                'https://experpai.com/#/index')
            "
            :href="'data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlIHsNCiAgZGlzcGxheTogbm9uZTsNCn0NCi5pbXBvd2VyQm94IC5zdGF0dXMuc3RhdHVzX2Jyb3dzZXIgew0KICBkaXNwbGF5OiBub25lOw0KfQ0KLmltcG93ZXJCb3ggLnFyY29kZSB7DQogIGJvcmRlcjogbm9uZTsNCiAgd2lkdGg6IDIwMHB4Ow0KICBoZWlnaHQ6IDIwMHB4Ow0KfQ0KLmltcG93ZXJCb3ggLnN0YXR1c3sNCiAgZGlzcGxheTogbm9uZQ0KfQ=='"
            rel="external nofollow"
            :state="state"
          >
          </wxlogin>
        </div>
      </div>
      <!-- <div
        v-if="!isWxLogin || hasBindPhone"
        class="login-btn margin-top-40"
        @click="loginAction"
      >
        {{ hasBindPhone ? "绑定手机号" : "登录" }}
      </div>
      <div class="mt24 line-box" v-if="!hasBindPhone">
        <div class="line-img">
          <img src="@/assets/img/left-line.png" alt="" />
        </div>
        <div class="text-main-color f12 margin-left-10 margin-right-10">
          微信扫码登录
        </div>
        <div class="line-img">
          <img src="@/assets/img/right-line.png" alt="" />
        </div>
      </div> -->
      <!-- <div
        class="margin-top-20 wx-box"
        @click="checkCodeLogin"
        v-if="!bindPhoneOnly"
      >
        <img v-if="!isWxLogin" src="@/assets/img/wechat.png" alt="" />
        <div class="text-main-color" v-else>短信快捷登录</div>
      </div> -->
    </div>
  </div>
</template>


<script>
import Util from "@/util/util.js";
import util from "../util/util";
import wxlogin from "vue-wxlogin";
import { getToken } from '../util/cookie';
import  cryptoDES  from "../util/cryptoDES"
export default {
  data() {
    return {
      userName: "",
      verificationCode: "",
      timeNum: 60,
      isWxLogin: true,
      isBindPhone: false,
      qrCode: "",
      wechat_app_id: "wx31df4c948057508c",
    };
  },
  props: {
    bindPhoneOnly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    wxlogin,
  },
  computed: {
    hasBindPhone() {
      if (this.bindPhoneOnly) {
        this.isBindPhone = true;
      }
      return false;
    },
    token(){
      return getToken()
    },
    state(){
      let stateNum = parseInt(Math.random()*100)+1;
      return cryptoDES.encrypt(stateNum);
    }
  },

  mounted() {
   
  },
  methods: {
    checkCodeLogin() {
      // this.isWxLogin = !this.isWxLogin;
      // this.isBindPhone = false;
      // this.$emit("wxLogin");
    },
    closeAction() {
      // this.isWxLogin = false;
      // this.isBindPhone = false;
      this.$emit("close");
    },
    getCode() {
      if (!Util.checkPhoneNum(this.userName)) {
        Util.Message("error", "手机号格式不正确");
        return;
      }
      this.doLoop();
      let that = this;
      let para = {
        phone: this.userName,
        type: 1,
      };
      util.axiosFun(that, "/xzxj/web/user/send", "post", para).then((res) => {
        console.log("res", res);
      });
    },

    doLoop() {
      let that = this;
      var timer = setInterval(function () {
        if (that.timeNum == 0) {
          // 清除定时器和复原按钮
          clearInterval(timer);

          that.timeNum = 60; // 重新赋值时间变量
        } else {
          that.timeNum = that.timeNum - 1;
        }
      }, 1000);
    },

    loginAction() {
      if (!Util.checkPhoneNum(this.userName)) {
        Util.Message("error", "手机号格式不正确");
        return;
      }
      let para = {
        phone: this.userName,
        code: this.verificationCode,
      };
      this.$emit("login", para);
    },
  },
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(55, 55, 55, 0.6);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-confirm {
  width: 400px;
  box-sizing: border-box;
  padding: 30px 20px;
  background-color: #fff;
  border-radius: 6px;
  position: relative;
}

.close-btn {
  position: absolute;
  right: 10px;
  top: 10px;
}

.close-btn img {
  width: 18px;
  height: 18px;
}

.login-btn {
  background: #3d7eff;
  color: #fff;
  font-size: 16px;
  text-align: center;
  height: 48px;
  line-height: 48px;
  width: 360px;
  border-radius: 8px;
}

.code-box {
  width: 240px;
}

.code-btn {
  font-size: 14px;
  margin-left: 20px;
  height: 40px;
  width: 100px;
  text-align: center;
  line-height: 40px;
  color: #3d7eff;
  border: solid 1px #3d7eff;
}

.time-btn {
  font-size: 14px;
  margin-left: 20px;
  height: 40px;
  width: 100px;
  text-align: center;
  line-height: 40px;
  color: #999;
  border: solid 1px #efefef;
}

.line-box {
  display: flex;
  justify-content: center;
  align-items: center;
}

.line-img {
  width: 48px;
  height: 1px;
  display: flex;
}

.wx-code-box {
  display: flex;
  justify-content: center;
  align-content: center;
  margin-top: 20px;
}

.wx-code {
  height: 240px;
}

.wx-code img {
  width: 240px;
  height: 240px;
}

.wx-box {
  display: flex;
  justify-content: center;
}

.wx-box img {
  width: 48px;
  height: 48px;
}

.line-img img {
  height: 100%;
  width: 1005;
}

.f20 {
  font-size: 20px;
}
.f14 {
  font-size: 14px;
}

.f12 {
  font-size: 12px;
}

.mt24 {
  margin-top: 24px;
}
.text-bold {
  font-weight: 600;
}

.text-center {
  text-align: center;
}

.margin-top-20 {
  margin-top: 20px;
}

.flex-row {
  display: flex;
}

.margin-left-10 {
  margin-left: 10px;
}

.margin-top-40 {
  margin-top: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/loginAlert.vue